(function(){

  // ══ SEARCH — desktop + mobile optimized ══
  var PSURL = '/search/suggest.json';
  var sw    = document.getElementById('ch-sw');
  var sf    = document.getElementById('ch-sf');
  var sb    = document.getElementById('ch-sb');
  var sc    = document.getElementById('ch-sc');
  var drop  = document.getElementById('ch-sr-dropdown');
  var mobSf = document.getElementById('ch-mob-sf');
  var mobSb = document.getElementById('ch-mob-sb');
  var mobDrop = document.getElementById('ch-mob-sr');
  if (mobDrop) document.body.appendChild(mobDrop);
  var debT;
  var debM;
  var activeDesktopIndex = -1;
  var activeMobileIndex = -1;
  var searchCache = {};
  var collectionCache = {};
  var countCache = {};
  var desktopRequestId = 0;
  var mobileRequestId = 0;
  var desktopCtrl = null;
  var mobileCtrl = null;

  var POPULAR = [
    { label: 'Dish racks', url: '/collections/dish-racks-drying' },
    { label: 'Kitchen storage', url: '/collections/kitchen-storage' },
    { label: 'Bathroom shelving', url: '/collections/bathroom-shelving' },
    { label: 'Plant stands', url: '/collections/plant-stands-garden' },
    { label: 'Desk organisation', url: '/collections/desk-organisation' },
    { label: 'Towel racks', url: '/collections/towel-racks-rails' },
    { label: 'Food storage', url: '/collections/food-storage' },
    { label: 'Mirrors', url: '/collections/mirrors' }
  ];
  // Textos que rotan en la barra vacía (búsquedas más frecuentes, análisis 2026-10-13)
  var PLACEHOLDER_TERMS = ['bread box', 'under sink storage', 'jewellery organiser', 'shoe storage', 'pegboard accessories'];
  var POPULAR_CATEGORIES = [
    { label: 'Kitchen', url: '/collections/kitchen' },
    { label: 'Storage', url: '/collections/storage-organisation' },
    { label: 'Bathroom', url: '/collections/bathroom' },
    { label: 'Living', url: '/collections/home-decor-living' },
    { label: 'Office & Desk', url: '/collections/home-office-desk' },
    { label: 'Pets', url: '/collections/pets' },
    { label: 'Kids', url: '/collections/kids' }
  ];
  var SEMANTIC_RULES = [
    { keys: ['gift', 'present', 'mum', 'mom', 'mother'], chips: ['Jewellery organisers', 'Bathroom storage', 'Living room accessories'] },
    { keys: ['bath', 'bathroom', 'towel'], chips: ['Bathroom storage', 'Towel racks', 'Bathroom shelving'] },
    { keys: ['kitchen', 'food', 'dish', 'coffee'], chips: ['Kitchen organisation', 'Dish racks', 'Food storage'] },
    { keys: ['desk', 'office', 'study'], chips: ['Desk organisation', 'Whiteboards & boards', 'Laptop desks & bed trays'] },
    { keys: ['living', 'decor', 'plant'], chips: ['Mirrors', 'Living room accessories', 'Plant stands & garden'] }
  ];
  var ICO_S = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';
  var ICO_A = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  var ICO_H = '<svg class="ch-ico-history" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/></svg>';
  var ICO_TAG = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41 11 3.83V2H2v9h1.83l9.58 9.59a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.83z"/><circle cx="7" cy="7" r="1"/></svg>';

  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function escAttr(s){
    return esc(s).replace(/`/g, '&#96;');
  }
  function buildSearchUrl(query){
    var q = (query || '').trim();
    return '/search?q=' + encodeURIComponent(q) + '&type=product';
  }
  function toNum(v){
    if (v === null || typeof v === 'undefined') return NaN;
    if (typeof v === 'number') return v;
    var clean = String(v).replace(/[^0-9.-]/g, '');
    return parseFloat(clean);
  }
  function getPriceValue(product){
    if (!product) return NaN;
    if (product.variants && product.variants.length) {
      var vals = product.variants
        .map(function(v){ return toNum(v && v.price); })
        .filter(function(n){ return !isNaN(n) && n > 0; });
      if (vals.length) return Math.min.apply(null, vals);
    }
    var candidates = [product.price_min, product.price, product.price_max];
    for (var i = 0; i < candidates.length; i += 1) {
      var n = toNum(candidates[i]);
      if (!isNaN(n) && n > 0) return n;
    }
    return NaN;
  }
  function fmt(priceValue){
    var n = toNum(priceValue);
    if (isNaN(n) || n <= 0) return '';
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(n);
  }
  function getCompactShipDateLabel() {
  var now = new Date();
  var day = now.getDay();
  var ship = new Date(now);

  if (day === 5) {
    ship.setDate(now.getDate() + 3); // Viernes → lunes
  } else if (day === 6) {
    ship.setDate(now.getDate() + 2); // Sábado → lunes
  } else {
    ship.setDate(now.getDate() + 1); // resto → mañana
  }

  var tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  var isTomorrow = ship.toDateString() === tomorrow.toDateString();

  if (isTomorrow) return 'Shipping Tomorrow';

  var compact = ship.toLocaleDateString('en-AU', {
    weekday: 'short', day: 'numeric', month: 'short'
  }).replace(',', '');
  return 'Shipping ' + compact;
}

  function buildShippingEtaHtml(context){
    var cls = 'ch-sr-prod-eta';
    var iconCls = 'ch-sr-prod-eta-icon';
    var dateCls = 'ch-sr-prod-eta-date';
    if (context === 'search-mobile') {
      cls = 'ch-mob-sr-prod-eta';
      iconCls = 'ch-mob-sr-prod-eta-icon';
      dateCls = 'ch-mob-sr-prod-eta-date';
    } else if (context === 'mega') {
      cls = 'ch-card-eta';
      iconCls = 'ch-card-eta-icon';
      dateCls = 'ch-card-eta-date';
    }
    return '<span class="' + cls + '">'
      + '<span class="' + iconCls + '" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="10" rx="2"></rect><path d="M15 9h4l3 3v4h-7V9z"></path><circle cx="6" cy="18" r="2"></circle><circle cx="18" cy="18" r="2"></circle></svg></span>'
      + '<span class="' + dateCls + '">' + esc(getCompactShipDateLabel()) + '</span>'
      + '</span>';
  }
  function normalizeQ(q){
    return (q || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }
  function trackSearch(eventName, payload){
    var data = payload || {};
    data.event = 'ch_' + eventName;
    data.source = 'header_search';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    // Clics en el desplegable: no pasan por /search, así que GA4 no los cuenta como búsqueda
    if (eventName === 'result_click' && typeof gtag === 'function') {
      gtag('event', 'search_dropdown_click', {
        search_term: data.query,
        click_type: data.type,
        device_context: data.context || 'desktop'
      });
    }
    try {
      document.dispatchEvent(new CustomEvent('ch:search:' + eventName, { detail: data }));
    } catch (e) {}
  }
  function highlight(text, query){
    var safeText = esc(text);
    var terms = normalizeQ(query).split(' ').filter(function(t){ return t.length > 1; });
    if (!terms.length) return safeText;
    var pattern = terms.map(function(t){ return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|');
    if (!pattern) return safeText;
    return safeText.replace(new RegExp('(' + pattern + ')', 'ig'), '<mark>$1</mark>');
  }

  var HISTORY_KEY = 'ch_search_history';
  function getHistory(){
    try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch(e){ return []; }
  }
  function saveToHistory(q){
    if(!q || q.length < 2) return;
    var h = getHistory().filter(function(t){ return t.toLowerCase() !== q.toLowerCase(); });
    h.unshift(q);
    h = h.slice(0, 6);
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(h)); } catch(e){}
  }
  function getPersonalizedPopular(){
    var popular = POPULAR.slice();
    try {
      var wl = JSON.parse(localStorage.getItem('ch_wishlist') || '[]');
      if(!wl.length) return popular;
      var wlCategories = [];
      wl.forEach(function(item){
        var url = (item.url || '').toLowerCase();
        var title = (item.title || '').toLowerCase();
        POPULAR.forEach(function(term){
          var token = term.label.toLowerCase().split(' ')[0];
          if((url.includes(token) || title.includes(token)) && wlCategories.indexOf(term) === -1){
            wlCategories.push(term);
          }
        });
      });
      wlCategories.forEach(function(term){
        popular = popular.filter(function(t){ return t !== term; });
        popular.unshift(term);
      });
    } catch(e){}
    return popular;
  }
  function getSemanticChips(query, hasResults){
    var q = normalizeQ(query);
    if (!q) return [];
    var isLong = q.split(' ').length >= 3 || q.length >= 20;
    if (!isLong && hasResults) return [];
    var out = [];
    SEMANTIC_RULES.forEach(function(rule){
      var matched = rule.keys.some(function(k){ return q.indexOf(k) !== -1; });
      if (matched) {
        rule.chips.forEach(function(c){
          if (out.indexOf(c) === -1) out.push(c);
        });
      }
    });
    if (!out.length) {
      out = ['Bathroom storage', 'Jewellery organisers', 'Desk organisation'];
    }
    return out.slice(0, 3);
  }

  function getIntentTerms(query){
    var terms = normalizeQ(query).split(' ').filter(function(t){ return t.length > 2; });
    var stop = ['for', 'with', 'from', 'that', 'this', 'your', 'mum', 'mom', 'gift', 'home', 'the', 'and'];
    return terms.filter(function(t){ return stop.indexOf(t) === -1; });
  }
  function scoreProductIntent(product, query){
    var title = normalizeQ(product && product.title ? product.title : '');
    if (!title) return 0;
    var score = 0;
    getIntentTerms(query).forEach(function(t){
      if (title.indexOf(t) !== -1) score += 2;
      else if (t.length > 4 && title.indexOf(t.slice(0, 4)) !== -1) score += 1;
    });
    return score;
  }
  function filterProductsByIntent(products, query){
    var q = normalizeQ(query);
    if (!q) return products || [];
    var isLong = q.split(' ').length >= 3 || q.length >= 20;
    if (!isLong) return products || [];
    var scored = (products || []).map(function(p){
      return { p: p, s: scoreProductIntent(p, q) };
    }).filter(function(x){ return x.s > 0; });
    if (!scored.length) return [];
    scored.sort(function(a, b){ return b.s - a.s; });
    return scored.map(function(x){ return x.p; });
  }

  var _bestSellers = null;
  var _bsLoading = false;
  var _bsCallbacks = [];
  var _bsIds = {};
  var _newIds = {};
  var _newLoaded = false;
  function isAvailable(p){
    if (typeof p.available === 'boolean') return p.available;
    return (p.variants || []).some(function(v){ return v.available; });
  }
  // Misma regla que snippets/product-badges.liquid: top 35 de new-arrivals
  function loadNewArrivals(){
    if (_newLoaded) return;
    _newLoaded = true;
    fetch('/collections/new-arrivals/products.json?limit=35')
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(d){ (d.products || []).forEach(function(p){ _newIds[String(p.id)] = true; }); })
      .catch(function(){});
  }
  function getCompareValue(p){
    var v = p.compare_at_price_max;
    if (v === undefined && p.variants && p.variants[0]) v = p.variants[0].compare_at_price;
    var n = toNum(v);
    return isNaN(n) ? 0 : n;
  }
  function buildSearchBadges(p, priceValue, compareValue){
    var h = '';
    var id = String(p.id || '');
    if (id && _bsIds[id]) {
      h += '<span class="ch-product-badge ch-product-badge--best-seller" role="listitem"><svg class="ch-product-badge__icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 1.8l2.4 4.9 5.4.8-3.9 3.8.9 5.4L10 14.2 5.2 16.7l.9-5.4L2.2 7.5l5.4-.8z"></path></svg>Best Seller</span>';
    }
    if (compareValue > priceValue && priceValue > 0) {
      h += '<span class="ch-product-badge ch-product-badge--sale" role="listitem">-' + Math.round((compareValue - priceValue) * 100 / compareValue) + '%</span>';
    }
    if (id && _newIds[id]) {
      h += '<span class="ch-product-badge ch-product-badge--new-arrival" role="listitem">NEW</span>';
    }
    return h ? '<div class="ch-product-badges ch-product-badges--search" role="list" aria-label="Product highlights">' + h + '</div>' : '';
  }
  function loadBestSellers(cb){
    if(_bestSellers){ cb(_bestSellers); return; }
    _bsCallbacks.push(cb);
    if(_bsLoading) return;
    _bsLoading = true;
    fetch('/collections/best-sellers-auto/products.json?limit=30')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('best-sellers-auto failed')); })
      .catch(function(){
        return fetch('/collections/all/products.json?sort_by=best-selling&limit=4').then(function(r){ return r.json(); });
      })
      .then(function(d){
        var all = d.products || [];
        _bestSellers = all.filter(isAvailable).slice(0, 5); // solo con stock; desktop 5 por fila, móvil 4
        // Misma regla que snippets/product-badges.liquid: top 12 con stock
        all.filter(isAvailable).slice(0, 12).forEach(function(p){ _bsIds[String(p.id)] = true; });
        _bsCallbacks.forEach(function(fn){ fn(_bestSellers); });
        _bsCallbacks = [];
      })
      .catch(function(){
        _bestSellers = [];
        _bsCallbacks.forEach(function(fn){ fn([]); });
        _bsCallbacks = [];
      })
      .finally(function(){ _bsLoading = false; });
  }

  function fetchProducts(query, limit, mode){
    var key = normalizeQ(query) + '::' + String(limit);
    if (searchCache[key]) {
      return Promise.resolve({
        products: searchCache[key],
        requestId: mode === 'desktop' ? desktopRequestId : mobileRequestId
      });
    }
    var reqId;
    var ctrl;
    if (mode === 'desktop') {
      desktopRequestId += 1;
      reqId = desktopRequestId;
      if (desktopCtrl) desktopCtrl.abort();
      desktopCtrl = new AbortController();
      ctrl = desktopCtrl;
    } else {
      mobileRequestId += 1;
      reqId = mobileRequestId;
      if (mobileCtrl) mobileCtrl.abort();
      mobileCtrl = new AbortController();
      ctrl = mobileCtrl;
    }
    return fetch(PSURL + '?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit_scope]=each&resources[limit]=' + limit, { signal: ctrl.signal })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var results = (d.resources && d.resources.results) || {};
        var products = results.products || [];
        collectionCache[normalizeQ(query)] = results.collections || [];
        searchCache[key] = products;
        return { products: products, requestId: reqId };
      });
  }

  function buildProductCard(p, q, mobile){
    var oos = p.available === false;
    var name = highlight(p.title, q);
    var priceValue = getPriceValue(p);
    var price = fmt(priceValue);
    var compareValue = getCompareValue(p);
    var compare = compareValue > priceValue ? fmt(compareValue) : '';
    var badges = buildSearchBadges(p, priceValue, compareValue);
    var eta = oos ? '' : buildShippingEtaHtml(mobile ? 'search-mobile' : 'search-desktop');
    var wlOverlay = '<div class="ch-card-wl-overlay" onclick="event.preventDefault();event.stopPropagation();"><button class="ch-wl-sq" data-wishlist-btn data-product-id="' + escAttr(String(p.id)) + '" data-product-title="' + escAttr(p.title) + '" data-product-url="' + escAttr(p.url || ("/products/" + p.handle)) + '" data-product-image="' + escAttr((p.featured_image && p.featured_image.url) || (p.images && p.images[0] && p.images[0].src) || "") + '" data-product-price="' + escAttr(fmt(getPriceValue(p)) || "") + '" data-variant-id="' + escAttr(p.variants && p.variants[0] ? String(p.variants[0].id) : '') + '" data-category="' + escAttr((Array.isArray(p.tags) ? p.tags : (p.tags ? p.tags.split(',') : [])).reduce(function(a,t){return a||(t.trim().indexOf('cat:')===0?t.trim().replace('cat:',''):'')},'')) + '" aria-label="Add ' + escAttr(p.title) + ' to wishlist" aria-pressed="false" type="button"><span class="ch-wl-icon ch-wl-icon--empty" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 82 L14 46 L14 28 L28 14 L42 14 L50 22 L58 14 L72 14 L86 28 L86 46 Z" stroke="currentColor" stroke-width="7" stroke-linejoin="round" fill="none"/></svg></span><span class="ch-wl-icon ch-wl-icon--filled" aria-hidden="true" style="display:none"><svg width="15" height="15" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M50 82 L14 46 L14 28 L28 14 L42 14 L50 22 L58 14 L72 14 L86 28 L86 46 Z" stroke="currentColor" stroke-width="7" stroke-linejoin="round"/></svg></span></button></div>';
    var url = escAttr(p.url || ('/products/' + p.handle));
    var img;
    if (p.featured_image && p.featured_image.url) {
      img = '<img class="' + (mobile ? 'ch-mob-sr-prod-img' : 'ch-sr-prod-img') + '" src="' + escAttr(p.featured_image.url) + '&width=' + (mobile ? '300' : '200') + '" alt="" width="' + (mobile ? '300' : '200') + '" height="' + (mobile ? '300' : '200') + '" loading="lazy">';
    } else if (p.images && p.images[0] && p.images[0].src) {
      img = '<img class="' + (mobile ? 'ch-mob-sr-prod-img' : 'ch-sr-prod-img') + '" src="' + escAttr(p.images[0].src) + '&width=' + (mobile ? '300' : '200') + '" alt="" width="' + (mobile ? '300' : '200') + '" height="' + (mobile ? '300' : '200') + '" loading="lazy">';
    } else {
      img = mobile
        ? '<div class="ch-mob-sr-prod-img-ph"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C17B5E" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>'
        : '<div class="ch-sr-prod-img-ph"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C17B5E" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>';
    }
    img = '<span class="ch-sr-prod-media">' + img + '</span>';
    return '<a href="' + url + '" class="' + (mobile ? 'ch-mob-sr-prod' : 'ch-sr-prod') + (oos ? ' ch-sr-oos' : '') + '" data-sr-option data-sr-type="product">' + img + badges + wlOverlay

      + '<div class="' + (mobile ? 'ch-mob-sr-prod-info' : 'ch-sr-prod-info') + '"><span class="' + (mobile ? 'ch-mob-sr-prod-name' : 'ch-sr-prod-name') + '">' + name + '</span>'
      + (price ? '<span class="' + (mobile ? 'ch-mob-sr-prod-price' : 'ch-sr-prod-price') + '">' + esc(price) + (compare ? ' <s class="ch-sr-prod-compare">' + esc(compare) + '</s>' : '') + '</span>' : '')
      + eta
      + '</div></a>';
  }

  function buildSemanticChips(chips){
    if (!chips.length) return '';
    var h = '<div><span class="ch-sr-block-title">Explore</span><div class="ch-sr-chip-list">';
    chips.forEach(function(c){
      h += '<a href="' + buildSearchUrl(c) + '" class="ch-sr-chip" data-sr-option data-sr-type="semantic">' + ICO_TAG + esc(c) + '</a>';
    });
    h += '</div></div>';
    return h;
  }

  function buildNoResultsDesktop(q){
    var chips = getSemanticChips(q, false);
    var h = '<div class="ch-sr-right"><div class="ch-sr-nores">'
      + '<div class="ch-sr-nores-title">We couldn&#39;t find &ldquo;' + esc(q) + '&rdquo;</div>'
      + '<div class="ch-sr-nores-text">Try a different search, or start with our most popular picks.</div>'
      + buildSemanticChips(chips)
      + '<div><span class="ch-sr-block-title">Popular categories</span><div class="ch-sr-chip-list">';
    POPULAR_CATEGORIES.forEach(function(c){
      h += '<a class="ch-sr-chip" href="' + escAttr(c.url) + '" data-sr-option data-sr-type="category">' + esc(c.label) + '</a>';
    });
    h += '</div></div>';
    if (_bestSellers && _bestSellers.length) {
      h += '<div><span class="ch-sr-block-title">Best sellers in Australian homes</span><div class="ch-sr-grid">';
      _bestSellers.forEach(function(p){
        var m = { id: p.id, title: p.title, available: isAvailable(p), price: p.variants && p.variants[0] ? p.variants[0].price : '', compare_at_price_max: p.variants && p.variants[0] ? p.variants[0].compare_at_price : '', url: '/products/' + p.handle, images: p.images };
        h += buildProductCard(m, q, false);
      });
      h += '</div></div>';
    }
    h += '</div><div class="ch-sr-footer"><a href="' + buildSearchUrl(q) + '" class="ch-sr-see-all" data-sr-option data-sr-type="all">View all results ' + ICO_A + '</a></div></div>';
    return h;
  }

  function buildCollectionLinks(q){
    var cols = (collectionCache[normalizeQ(q)] || []).slice(0, 3);
    if (!cols.length) return '';
    var h = '<div class="ch-sr-collections"><span class="ch-sr-block-title">Shop the collection</span><div class="ch-sr-chip-list">';
    cols.forEach(function(c){
      h += '<a href="' + escAttr(c.url) + '" class="ch-sr-chip" data-sr-option data-sr-type="collection">' + esc(c.title) + ' ' + ICO_A + '</a>';
    });
    return h + '</div></div>';
  }

  function seeAllLabel(q){
    var n = countCache[normalizeQ(q)];
    return n ? 'View all ' + n + ' results' : 'View all results';
  }
  // Total real de /search (el desplegable solo recibe hasta 10 productos)
  function loadResultCount(q){
    var key = normalizeQ(q);
    if (!key || countCache[key] !== undefined) return;
    countCache[key] = 0;
    fetch(buildSearchUrl(q) + '&section_id=ch-search-count')
      .then(function(r){ return r.ok ? r.text() : ''; })
      .then(function(html){
        var m = html.match(/data-count="(\d+)"/);
        countCache[key] = m ? parseInt(m[1], 10) : 0;
        if (!countCache[key]) return;
        if (sf && normalizeQ(sf.value) === key) {
          var link = drop.querySelector('.ch-sr-see-all');
          if (link) link.innerHTML = seeAllLabel(q) + ' ' + ICO_A;
        }
        if (mobSf && normalizeQ(mobSf.value) === key) {
          var mobLink = mobDrop.querySelector('.ch-mob-sr-footer a');
          if (mobLink) mobLink.textContent = seeAllLabel(q) + ' \u2192';
        }
      })
      .catch(function(){});
  }

  // Banner promo (sections/header.liquid → #ch-sr-promo-tpl), con fechas opcionales
  var promoTpl = document.getElementById('ch-sr-promo-tpl');
  function promoActive(){
    if (!promoTpl) return false;
    var now = new Date();
    var start = promoTpl.getAttribute('data-start');
    var end = promoTpl.getAttribute('data-end');
    if (start && !isNaN(new Date(start + 'T00:00:00')) && now < new Date(start + 'T00:00:00')) return false;
    if (end && !isNaN(new Date(end + 'T23:59:59')) && now > new Date(end + 'T23:59:59')) return false;
    return true;
  }
  function buildPromo(){
    return promoActive() ? promoTpl.innerHTML : '';
  }

  // Fila Recent / Popular sobre los resultados (propuesta C)
  function buildLeft(){
    var history = getHistory();
    var popular = getPersonalizedPopular();
    var h = '<div class="ch-sr-strip">';
    if(history.length){
      h += '<span class="ch-sr-strip-title">Recent</span>';
      history.slice(0,2).forEach(function(t){
        h += '<a class="ch-sr-pill" href="'+buildSearchUrl(t)+'" data-sr-option data-sr-type="history">'+ICO_H+esc(t)+'</a>';
      });
      h += '<span class="ch-sr-strip-sep" aria-hidden="true"></span>';
    }
    h += '<span class="ch-sr-strip-title">Popular</span>';
    popular.slice(0, history.length ? 4 : 6).forEach(function(t){
      h += '<a class="ch-sr-pill" href="'+escAttr(t.url)+'" data-sr-option data-sr-type="popular">'+ICO_S+esc(t.label)+'</a>';
    });
    return h + '</div>';
  }

  function buildRight(products, q, loading){
    if(loading){
      return '<div class="ch-sr-right"><div class="ch-sr-empty"><span class="ch-sr-spinner"></span>Searching&hellip;</div></div>';
    }
    if(!q){
      if(!_bestSellers || !_bestSellers.length){
        return '<div class="ch-sr-right"><div class="ch-sr-empty" style="font-style:italic;opacity:0.5;">Start typing to search&hellip;</div></div>';
      }
      var bs = '<div class="ch-sr-right"><span class="ch-sr-right-title">Best sellers</span><div class="ch-sr-grid">';
      _bestSellers.forEach(function(p){
        var m = { id: p.id, title: p.title, available: isAvailable(p), price: p.variants && p.variants[0] ? p.variants[0].price : '', compare_at_price_max: p.variants && p.variants[0] ? p.variants[0].compare_at_price : '', url: '/products/' + p.handle, images: p.images };
        bs += buildProductCard(m, '', false);
      });
      bs += '</div></div>';
      return bs;
    }
    if(!products.length){
      trackSearch('no_results', { query: q });
      return buildNoResultsDesktop(q);
    }
    var g = '<div class="ch-sr-right"><span class="ch-sr-right-title">Results for &ldquo;'+esc(q)+'&rdquo;</span>' + buildCollectionLinks(q) + '<div class="ch-sr-grid">';
    products.forEach(function(p){ g += buildProductCard(p, q, false); });
    var chips = getSemanticChips(q, true);
    g += '</div>' + buildSemanticChips(chips)
      + '<div class="ch-sr-footer"><a href="' + buildSearchUrl(q) + '" class="ch-sr-see-all" data-sr-option data-sr-type="all">' + seeAllLabel(q) + ' '+ICO_A+'</a></div></div>';
    return g;
  }

  function setDesktopA11y(expanded){
    sf.setAttribute('role', 'combobox');
    sf.setAttribute('aria-autocomplete', 'list');
    sf.setAttribute('aria-controls', 'ch-sr-dropdown');
    sf.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    drop.setAttribute('role', 'listbox');
    drop.setAttribute('aria-label', 'Search suggestions');
  }
  function syncActiveOptionDesktop(){
    var opts = drop.querySelectorAll('[data-sr-option]');
    if (!opts.length || activeDesktopIndex < 0 || activeDesktopIndex >= opts.length) {
      sf.removeAttribute('aria-activedescendant');
      return;
    }
    opts.forEach(function(el, idx){
      if (!el.id) el.id = 'ch-sr-opt-' + idx;
      el.classList.toggle('ch-sr-option-active', idx === activeDesktopIndex);
    });
    sf.setAttribute('aria-activedescendant', opts[activeDesktopIndex].id);
  }

  function showDrop(products, q, loading){
    var promo = buildPromo();
    drop.innerHTML = buildLeft() + '<div class="ch-sr-body">' + buildRight(products, q, loading) + promo + '</div>';
    drop.classList.toggle('ch-sr-dropdown--promo', !!promo);
    // Desplegable ancho centrado en la pantalla (no bajo la barra)
    var swRect = sw.getBoundingClientRect();
    drop.style.setProperty('--ch-sr-center', Math.round(document.documentElement.clientWidth / 2 - swRect.left) + 'px');
    if (q && !loading && products.length) loadResultCount(q);
    if (window.CHWishlist && typeof window.CHWishlist.initBtns === 'function') window.CHWishlist.initBtns();
    drop.classList.add('open');
    activeDesktopIndex = -1;
    setDesktopA11y(true);
  }
  // ── Diccionario + Levenshtein ────────────────────────────────────────────────
  var chDict = null, chDictLoading = false, chDictCbs = [];
  function chFetchJson(url) {
    return fetch(url).then(function(r){ return r.ok ? r.json() : {}; }).catch(function(){ return {}; });
  }
  function chLoadDict() {
    if (chDict !== null || chDictLoading) return;
    chDictLoading = true;
    Promise.all([
      chFetchJson('/products.json?limit=250&page=1&fields=title'),
      chFetchJson('/products.json?limit=250&page=2&fields=title'),
      chFetchJson('/collections.json?limit=250&fields=title')
    ]).then(function(rs) {
      var titles = []
        .concat((rs[0].products || []).map(function(p){ return p.title; }))
        .concat((rs[1].products || []).map(function(p){ return p.title; }))
        .concat((rs[2].collections || []).map(function(c){ return c.title; }));
      var w = {};
      titles.forEach(function(t){
        t.toLowerCase().split(/[^a-z]+/).forEach(function(s){ if (s.length >= 4) w[s] = true; });
      });
      chDict = Object.keys(w);
      chDictLoading = false;
      chDictCbs.forEach(function(cb){ cb(); });
      chDictCbs = [];
    }).catch(function(){
      chDict = [];
      chDictLoading = false;
      chDictCbs.forEach(function(cb){ cb(); });
      chDictCbs = [];
    });
  }
  function chOnDictReady(cb) {
    if (chDict !== null) { cb(); return; }
    chDictCbs.push(cb);
  }
  function chLev(a, b) {
    var m = a.length, n = b.length, j;
    if (!m) return n; if (!n) return m;
    var prev = [], curr = [];
    for (j = 0; j <= n; j++) prev[j] = j;
    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (j = 1; j <= n; j++) {
        curr[j] = a[i-1] === b[j-1] ? prev[j-1] : 1 + Math.min(prev[j], curr[j-1], prev[j-1]);
      }
      var tmp = prev; prev = curr; curr = tmp;
    }
    return prev[n];
  }
  function chCorrectQuery(term) {
    if (!chDict || !chDict.length) return null;
    var words = term.toLowerCase().split(/\s+/);
    var changed = false;
    var out = words.map(function(word) {
      if (word.length < 4) return word;
      if (chDict.indexOf(word) !== -1) return word;
      var maxD = word.length >= 6 ? 2 : 1;
      var best = null, bestD = Infinity;
      chDict.forEach(function(dw) {
        var d = chLev(word, dw);
        if (d < bestD && d <= maxD) { bestD = d; best = dw; }
      });
      if (best) { changed = true; return best; }
      return word;
    });
    return changed ? out.join(' ') : null;
  }
  function chDictCorrect(origQ, origReqId, mode) {
    var curId = mode === 'desktop' ? desktopRequestId : mobileRequestId;
    if (origReqId !== curId) return;

    function showNone() {
      var nowId = mode === 'desktop' ? desktopRequestId : mobileRequestId;
      if (origReqId !== nowId) return;
      if (mode === 'desktop') showDrop([], origQ, false);
      else renderMob([], origQ);
    }

    function tryFix() {
      var nowId = mode === 'desktop' ? desktopRequestId : mobileRequestId;
      if (origReqId !== nowId) return;
      var fix = chCorrectQuery(origQ);
      if (!fix) return;
      fetchProducts(fix, 50, mode)
        .then(function(res) {
          var latestId = mode === 'desktop' ? desktopRequestId : mobileRequestId;
          if (res.requestId !== latestId) return;
          var filtered = filterProductsByIntent(res.products, fix);
          if (!filtered.length) return;
          var badge = document.createElement('p');
          badge.className = 'ch-fuzzy-correction';
          badge.innerHTML = 'Showing results for: <strong>' + esc(fix) + '</strong>';
          if (mode === 'desktop') {
            showDrop(filtered, fix, false);
            var right = drop.querySelector('.ch-sr-right');
            if (right) right.insertBefore(badge, right.firstChild);
          } else {
            renderMob(filtered, fix);
            mobDrop.insertBefore(badge, mobDrop.firstChild ? mobDrop.firstChild.nextSibling : null);
          }
        })
        .catch(function(err) { if (err && err.name === 'AbortError') return; });
    }

    if (chDict === null) {
      showNone();
      chDictCbs.push(tryFix);
    } else {
      var fix = chCorrectQuery(origQ);
      if (!fix) { showNone(); return; }
      fetchProducts(fix, 50, mode)
        .then(function(res) {
          var latestId = mode === 'desktop' ? desktopRequestId : mobileRequestId;
          if (res.requestId !== latestId) return;
          var filtered = filterProductsByIntent(res.products, fix);
          if (!filtered.length) { showNone(); return; }
          var badge = document.createElement('p');
          badge.className = 'ch-fuzzy-correction';
          badge.innerHTML = 'Showing results for: <strong>' + esc(fix) + '</strong>';
          if (mode === 'desktop') {
            showDrop(filtered, fix, false);
            var right = drop.querySelector('.ch-sr-right');
            if (right) right.insertBefore(badge, right.firstChild);
          } else {
            renderMob(filtered, fix);
            mobDrop.insertBefore(badge, mobDrop.firstChild ? mobDrop.firstChild.nextSibling : null);
          }
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          showNone();
        });
    }
  }
  // chLoadDict() se dispara al enfocar el buscador (desktop o mobile), no en cada carga de pagina — ver 'focus' listeners de sf/mobSf.
  // ── Fin diccionario ──────────────────────────────────────────────────────────

  function chBuildVariants(term) {
    var variants = []; var seen = {}; seen[term] = true;
    var s1 = term.replace(/(.)\1{2,}/g, '$1$1');
    if (!seen[s1]) { seen[s1] = true; variants.push(s1); }
    var s2 = (seen[s1] ? term : s1).replace(/(.)\1+/g, '$1');
    if (!seen[s2]) { seen[s2] = true; variants.push(s2); }
    return variants;
  }
  function tryFuzzyDesktop(origQ, variants, idx, origReqId) {
    if (idx >= variants.length) {
      chDictCorrect(origQ, desktopRequestId, 'desktop');
      return;
    }
    var corrQ = variants[idx];
    fetchProducts(corrQ, 50, 'desktop')
      .then(function(res){
        if (res.requestId !== desktopRequestId) return;
        var filtered = filterProductsByIntent(res.products, corrQ);
        if (filtered.length > 0) {
          showDrop(filtered, corrQ, false);
          var badge = document.createElement('p');
          badge.className = 'ch-fuzzy-correction';
          badge.innerHTML = 'Showing results for: <strong>' + esc(corrQ) + '</strong>';
          var right = drop.querySelector('.ch-sr-right');
          if (right) right.insertBefore(badge, right.firstChild);
        } else {
          tryFuzzyDesktop(origQ, variants, idx + 1, origReqId);
        }
      })
      .catch(function(err){
        if (err && err.name === 'AbortError') return;
        if (origReqId === desktopRequestId) tryFuzzyDesktop(origQ, variants, idx + 1, origReqId);
      });
  }
  function tryFuzzyMobile(origQ, variants, idx, origReqId) {
    if (idx >= variants.length) {
      chDictCorrect(origQ, mobileRequestId, 'mobile');
      return;
    }
    var corrQ = variants[idx];
    fetchProducts(corrQ, 50, 'mobile')
      .then(function(res){
        if (res.requestId !== mobileRequestId) return;
        var filtered = filterProductsByIntent(res.products, corrQ);
        if (filtered.length > 0) {
          renderMob(filtered, corrQ);
          var badge = document.createElement('p');
          badge.className = 'ch-fuzzy-correction';
          badge.innerHTML = 'Showing results for: <strong>' + esc(corrQ) + '</strong>';
          mobDrop.insertBefore(badge, mobDrop.firstChild ? mobDrop.firstChild.nextSibling : null);
        } else {
          tryFuzzyMobile(origQ, variants, idx + 1, origReqId);
        }
      })
      .catch(function(err){
        if (err && err.name === 'AbortError') return;
        if (origReqId === mobileRequestId) tryFuzzyMobile(origQ, variants, idx + 1, origReqId);
      });
  }
  function runDesktopSearch(q){
    if (!q || q.length < 2) {
      showDrop([], '', false);
      return;
    }
    showDrop([], q, true);
    fetchProducts(q, 50, 'desktop')
      .then(function(res){
        if (res.requestId !== desktopRequestId) return;
        var filtered = filterProductsByIntent(res.products, q);
        if (filtered.length > 0) {
          showDrop(filtered, q, false);
        } else if (q.length > 2) {
          tryFuzzyDesktop(q, chBuildVariants(q), 0, desktopRequestId);
        } else {
          showDrop([], q, false);
        }
      })
      .catch(function(err){
        if (err && err.name === 'AbortError') return;
        showDrop([], q, false);
      });
  }

  function navigateToSearch(query){
    var q = (query || '').trim();
    if(!q) return;
    saveToHistory(q);
    window.location.href = buildSearchUrl(q);
  }
  function updateDesktopCloseVisibility(){
    if (!sc || !sf) return;
    sc.classList.toggle('is-hidden', !sf.value.trim());
  }

  // Placeholder rotativo animado: capa de texto sobre la barra (el placeholder nativo no se anima);
  // se oculta con foco o texto. Con "reducir movimiento" se queda el placeholder nativo fijo.
  function setupRotatingPlaceholder(input, wrap){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!input || !wrap || reduceMotion || !PLACEHOLDER_TERMS.length) return;
    var ph = document.createElement('span');
    ph.className = 'ch-sf-ph';
    ph.setAttribute('aria-hidden', 'true');
    ph.textContent = input.getAttribute('placeholder') || '';
    input.setAttribute('placeholder', '');
    wrap.insertBefore(ph, input.nextSibling);
    var syncPh = function(){ wrap.classList.toggle('ch-sf-ph-hide', document.activeElement === input || !!input.value); };
    input.addEventListener('focus', syncPh);
    input.addEventListener('blur', syncPh);
    input.addEventListener('input', syncPh);
    input.addEventListener('ch:sync-ph', syncPh);
    syncPh();
    var phIndex = 0;
    setInterval(function(){
      syncPh();
      if (wrap.classList.contains('ch-sf-ph-hide')) return;
      var next = 'Try \u201C' + PLACEHOLDER_TERMS[phIndex] + '\u201D\u2026';
      phIndex = (phIndex + 1) % PLACEHOLDER_TERMS.length;
      ph.classList.remove('is-in');
      ph.classList.add('is-out');
      setTimeout(function(){
        ph.textContent = next;
        ph.classList.remove('is-out');
        void ph.offsetWidth;
        ph.classList.add('is-in');
      }, 350);
    }, 4000);
  }

  if (sf && drop && sw) {
    // Velo sobre la página: sigue el estado .open del desplegable; el clic en él cuenta como clic fuera
    var srScrim = document.createElement('span'); // span: Dawn oculta div:empty
    srScrim.className = 'ch-sr-scrim';
    srScrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(srScrim);
    new MutationObserver(function(){
      srScrim.classList.toggle('is-on', drop.classList.contains('open'));
    }).observe(drop, { attributes: true, attributeFilter: ['class'] });
    updateDesktopCloseVisibility();
    setDesktopA11y(false);
    setupRotatingPlaceholder(sf, sw);
    sf.addEventListener('focus', function(){
      chLoadDict();
      loadNewArrivals();
      var q = sf.value.trim();
      updateDesktopCloseVisibility();
      if (q.length >= 2) {
        runDesktopSearch(q);
      } else if(_bestSellers){
        showDrop([], '', false);
      } else {
        drop.innerHTML = buildLeft() + '<div class="ch-sr-body"><div class="ch-sr-right"><div class="ch-sr-empty"><span class="ch-sr-spinner"></span></div></div></div>';
        drop.classList.add('open');
        setDesktopA11y(true);
        loadBestSellers(function(){ if(!sf.value.trim()) showDrop([], '', false); });
      }
    });
    sf.addEventListener('input', function(){
      var q = sf.value.trim();
      updateDesktopCloseVisibility();
      trackSearch('typed', { query: q, length: q.length });
      if(q.length < 2){ showDrop([], '', false); return; }
      clearTimeout(debT);
      debT = setTimeout(function(){
        runDesktopSearch(q);
      }, 220);
    });
    sf.addEventListener('keydown', function(e){
      var opts = drop.querySelectorAll('[data-sr-option]');
      if (e.key === 'ArrowDown' && opts.length) {
        e.preventDefault();
        activeDesktopIndex = (activeDesktopIndex + 1) % opts.length;
        syncActiveOptionDesktop();
        opts[activeDesktopIndex].focus();
        return;
      }
      if (e.key === 'ArrowUp' && opts.length) {
        e.preventDefault();
        activeDesktopIndex = activeDesktopIndex <= 0 ? opts.length - 1 : activeDesktopIndex - 1;
        syncActiveOptionDesktop();
        opts[activeDesktopIndex].focus();
        return;
      }
      if(e.key === 'Enter'){
        if (activeDesktopIndex >= 0 && opts[activeDesktopIndex]) {
          e.preventDefault();
          opts[activeDesktopIndex].click();
          return;
        }
        if(sf.value.trim()){
          navigateToSearch(sf.value.trim());
        }
      }
      if(e.key === 'Escape'){
        drop.classList.remove('open');
        setDesktopA11y(false);
        sf.blur();
      }
    });
    sb.addEventListener('click', function(){
      if(sf.value.trim()) navigateToSearch(sf.value.trim());
      else sf.focus();
    });
    if (sc) {
      sc.addEventListener('click', function(){
        sf.value = '';
        updateDesktopCloseVisibility();
        drop.classList.remove('open');
        setDesktopA11y(false);
        sf.focus();
      });
    }
    drop.addEventListener('click', function(e){
      if (!e.target || typeof e.target.closest !== 'function') return;
      var link = e.target.closest('[data-sr-option], .ch-sr-see-all, .ch-sr-prod');
      if (!link) return;
      var q = sf.value.trim();
      if (q) saveToHistory(q);
      trackSearch('result_click', {
        query: q,
        type: link.getAttribute('data-sr-type') || 'result',
        href: link.getAttribute('href') || ''
      });
      var params = new URLSearchParams((link.getAttribute('href') || '').split('?')[1] || '');
      var hrefQ = params.get('q');
      if (hrefQ) saveToHistory(hrefQ);
    });
    drop.addEventListener('keydown', function(e){
      var opts = drop.querySelectorAll('[data-sr-option]');
      if (!opts.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeDesktopIndex = (activeDesktopIndex + 1) % opts.length;
        syncActiveOptionDesktop();
        opts[activeDesktopIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeDesktopIndex = activeDesktopIndex <= 0 ? opts.length - 1 : activeDesktopIndex - 1;
        syncActiveOptionDesktop();
        opts[activeDesktopIndex].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        drop.classList.remove('open');
        setDesktopA11y(false);
        sf.focus();
      }
    });
    document.addEventListener('click', function(e){
      if(!sw.contains(e.target)){
        drop.classList.remove('open');
        setDesktopA11y(false);
      }
    });
  }

  function buildNoResultsMobile(q){
    var chips = getSemanticChips(q, false);
    var h = '<div class="ch-mob-nores"><div class="ch-mob-nores-title">We couldn&#39;t find &ldquo;' + esc(q) + '&rdquo;</div>'
      + '<div class="ch-mob-nores-text">Try a different search, or start with our most popular picks.</div><div class="ch-mob-chip-list">';
    chips.forEach(function(c){
      h += '<a href="' + buildSearchUrl(c) + '" class="ch-mob-chip" data-mob-sr-option data-mob-type="semantic">' + esc(c) + '</a>';
    });
    POPULAR_CATEGORIES.forEach(function(c){
      h += '<a href="' + escAttr(c.url) + '" class="ch-mob-chip" data-mob-sr-option data-mob-type="category">' + esc(c.label) + '</a>';
    });
    h += '</div>';
    if (_bestSellers && _bestSellers.length) {
      h += '<div class="ch-sr-block-title">Best sellers in Australian homes</div><div class="ch-mob-sr-grid">';
      _bestSellers.slice(0, 4).forEach(function(p){
        var m = { id: p.id, title: p.title, available: isAvailable(p), price: p.variants && p.variants[0] ? p.variants[0].price : '', compare_at_price_max: p.variants && p.variants[0] ? p.variants[0].compare_at_price : '', url: '/products/' + p.handle, images: p.images };
        h += buildProductCard(m, q, true).replace('data-sr-option', 'data-mob-sr-option');
      });
      h += '</div>';
    }
    h += '</div><div class="ch-mob-sr-footer"><a href="' + buildSearchUrl(q) + '" data-mob-sr-option data-mob-type="all">View all results →</a></div>';
    return h;
  }

  // Panel móvil al tocar la barra: recientes + categorías (sections/header.liquid → #ch-mob-cat-tpl)
  var mobCatTpl = document.getElementById('ch-mob-cat-tpl');
  // Fila fija arriba del panel: título según el estado + botón para cerrar
  function buildMobTop(title){
    return '<div class="ch-mob-sr-top"><span class="ch-mob-sr-title">' + title + '</span>'
      + '<button type="button" class="ch-mob-sr-close" aria-label="Close search">Close '
      + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';
  }
  function renderMobEmpty(){
    var history = getHistory();
    var h = buildMobTop(history.length ? 'Recent' : 'Shop by category');
    if (history.length) {
      h += '<div class="ch-mob-sr-block"><div class="ch-mob-pills">';
      history.slice(0, 4).forEach(function(t){
        h += '<a class="ch-mob-pill" href="' + buildSearchUrl(t) + '" data-mob-sr-option data-mob-type="history">' + ICO_H + esc(t) + '</a>';
      });
      h += '</div></div>';
    }
    if (mobCatTpl) {
      h += '<div class="ch-mob-sr-block ch-mob-sr-block--white">' + (history.length ? '<span class="ch-mob-sr-title">Shop by category</span>' : '') + mobCatTpl.innerHTML + '</div>';
    }
    mobDrop.innerHTML = h;
    mobDrop.classList.add('open');
    mobSf.setAttribute('aria-expanded', 'true');
    activeMobileIndex = -1;
  }
  function buildMobCollections(q){
    var cols = (collectionCache[normalizeQ(q)] || []).slice(0, 3);
    if (!cols.length) return '';
    var h = '<div class="ch-mob-pills ch-mob-pills--scroll">';
    cols.forEach(function(c){
      h += '<a class="ch-mob-pill ch-mob-pill--col" href="' + escAttr(c.url) + '" data-mob-sr-option data-mob-type="collection">' + esc(c.title) + ' \u2192</a>';
    });
    return h + '</div>';
  }

  function renderMob(products, q){
    if(!q || q.length < 2){ renderMobEmpty(); return; }
    if(!products.length){
      mobDrop.innerHTML = buildMobTop('No results') + buildNoResultsMobile(q);
      trackSearch('no_results', { query: q, context: 'mobile' });
    } else {
      var g = buildMobTop('Results for \u201C' + esc(q) + '\u201D') + buildMobCollections(q) + '<div class="ch-mob-sr-grid">';
      products.forEach(function(p){ g += buildProductCard(p, q, true).replace('data-sr-option', 'data-mob-sr-option'); });
      g += '</div><div class="ch-mob-sr-footer"><a href="' + buildSearchUrl(q) + '" data-mob-sr-option data-mob-type="all">' + seeAllLabel(q) + ' \u2192</a></div>';
      mobDrop.innerHTML = g;
      if (window.CHWishlist && typeof window.CHWishlist.initBtns === 'function') window.CHWishlist.initBtns();
      loadResultCount(q);
    }
    mobDrop.classList.add('open');
    mobSf.setAttribute('aria-expanded', 'true');
    activeMobileIndex = -1;
  }

  if(mobSf && mobDrop){
    mobSf.setAttribute('role', 'combobox');
    mobSf.setAttribute('aria-autocomplete', 'list');
    mobSf.setAttribute('aria-controls', 'ch-mob-sr');
    mobSf.setAttribute('aria-expanded', 'false');
    mobDrop.setAttribute('role', 'listbox');
    mobDrop.setAttribute('aria-label', 'Mobile search suggestions');
    mobSf.addEventListener('input', function(){
      var q = mobSf.value.trim();
      trackSearch('typed', { query: q, length: q.length, context: 'mobile' });
      if(q.length < 2){ clearTimeout(debM); renderMobEmpty(); return; }
      clearTimeout(debM);
      mobDrop.innerHTML = '<div style="padding:16px;text-align:center;font-family: var(--ch-font-ui);font-size:12px;color:#8A8680;">'
        + '<span style="display:inline-block;width:14px;height:14px;border:2px solid rgba(193,123,94,0.2);border-top-color:#C17B5E;border-radius:50%;animation:ch-spin 0.7s linear infinite;vertical-align:middle;margin-right:6px;"></span>'
        + 'Searching...</div>';
      mobDrop.classList.add('open');
      mobSf.setAttribute('aria-expanded', 'true');
      debM = setTimeout(function(){
        fetchProducts(q, 50, 'mobile')
          .then(function(res){
            if (res.requestId !== mobileRequestId) return;
            var filtered = filterProductsByIntent(res.products, q);
            if (filtered.length > 0) {
              renderMob(filtered, q);
            } else if (q.length > 2) {
              tryFuzzyMobile(q, chBuildVariants(q), 0, mobileRequestId);
            } else {
              renderMob([], q);
            }
          })
          .catch(function(err){
            if (err && err.name === 'AbortError') return;
            mobDrop.classList.remove('open');
            mobSf.setAttribute('aria-expanded', 'false');
          });
      }, 260);
    });
    mobSf.addEventListener('keydown', function(e){
      var opts = mobDrop.querySelectorAll('[data-mob-sr-option]');
      if (e.key === 'ArrowDown' && opts.length) {
        e.preventDefault();
        activeMobileIndex = (activeMobileIndex + 1) % opts.length;
        opts[activeMobileIndex].focus();
        return;
      }
      if (e.key === 'ArrowUp' && opts.length) {
        e.preventDefault();
        activeMobileIndex = activeMobileIndex <= 0 ? opts.length - 1 : activeMobileIndex - 1;
        opts[activeMobileIndex].focus();
        return;
      }
      if(e.key === 'Enter' && mobSf.value.trim()){
        if (activeMobileIndex >= 0 && opts[activeMobileIndex]) {
          e.preventDefault();
          opts[activeMobileIndex].click();
          return;
        }
        navigateToSearch(mobSf.value.trim());
      }
      if(e.key === 'Escape'){ mobDrop.classList.remove('open'); mobSf.setAttribute('aria-expanded', 'false'); mobSf.blur(); }
    });
    function lockBodyScroll(lock){
      try {
        if (lock) {
          document.documentElement.style.overflow = 'hidden';
          document.body.classList.add('ch-search-open-mobile');
        } else {
          document.documentElement.style.overflow = '';
          document.body.classList.remove('ch-search-open-mobile');
        }
      } catch(e) {}
    }
    function closeMobileSearch(){
      mobDrop.classList.remove('open');
      mobSf.setAttribute('aria-expanded', 'false');
      updateMobileCloseVisibility();
    }
    function openMobileSearch(){
      updateMobileCloseVisibility();
      loadNewArrivals();
      loadBestSellers(function(){});
      if (mobSf.value.trim().length < 2) renderMobEmpty();
    }
    function updateMobileCloseVisibility(){
      var mobCloseBtn = document.getElementById('ch-mob-close');
      if (!mobCloseBtn || !mobSf) return;
      mobCloseBtn.classList.toggle('is-hidden', !mobSf.value.trim());
    }
    updateMobileCloseVisibility();
    setupRotatingPlaceholder(mobSf, mobSf.closest('.ch-mob-search-wrap'));
    // Con el panel abierto se oculta el chatbot (su dock va a z-index 3000 en móvil y taparía el panel)
    new MutationObserver(function(){
      document.body.classList.toggle('ch-mob-sr-open', mobDrop.classList.contains('open'));
    }).observe(mobDrop, { attributes: true, attributeFilter: ['class'] });
    mobSf.addEventListener('focus', function(){ chLoadDict(); openMobileSearch(); });
    mobSf.addEventListener('input', function(){ updateMobileCloseVisibility(); });
    document.addEventListener('click', function(e){
      if(!mobSf.closest('.ch-mob-search').contains(e.target) && !mobDrop.contains(e.target)){
        closeMobileSearch();
      }
    });
    mobDrop.addEventListener('click', function(e){
      if (!e.target || typeof e.target.closest !== 'function') return;
      var link = e.target.closest('[data-mob-sr-option]');
      if (!link) return;
      var q = mobSf.value.trim();
      if (q) saveToHistory(q);
      trackSearch('result_click', {
        query: q,
        type: link.getAttribute('data-mob-type') || 'result',
        href: link.getAttribute('href') || '',
        context: 'mobile'
      });
    });
    mobDrop.addEventListener('keydown', function(e){
      var opts = mobDrop.querySelectorAll('[data-mob-sr-option]');
      if (!opts.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeMobileIndex = (activeMobileIndex + 1) % opts.length;
        opts[activeMobileIndex].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeMobileIndex = activeMobileIndex <= 0 ? opts.length - 1 : activeMobileIndex - 1;
        opts[activeMobileIndex].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeMobileSearch();
        mobSf.focus();
      }
    });
    mobDrop.addEventListener('click', function(e){
      if (!e.target || typeof e.target.closest !== 'function' || !e.target.closest('.ch-mob-sr-close')) return;
      mobSf.value = '';
      updateMobileCloseVisibility();
      closeMobileSearch();
      mobSf.blur();
    });
    var mobClose = document.getElementById('ch-mob-close');
    if (mobClose) {
      mobClose.addEventListener('click', function(){
        mobSf.value = '';
        updateMobileCloseVisibility();
        closeMobileSearch();
        mobSf.blur();
      });
    }
    if(mobSb){
      mobSb.addEventListener('click', function(){
        if(mobSf && mobSf.value.trim()) navigateToSearch(mobSf.value.trim());
        else if(mobSf) mobSf.focus();
      });
    }
  } else if(mobSb){
    mobSb.addEventListener('click', function(){
      if(mobSf && mobSf.value.trim()) navigateToSearch(mobSf.value.trim());
      else if(mobSf) mobSf.focus();
    });
  }

  // ══ MOBILE DRAWER ══
  var mask = document.getElementById('ch-mask');
  var ham  = document.getElementById('ch-ham');
  var pc   = document.getElementById('ch-pc');
  var drawerScrollY = 0;
  function lockDrawerScroll(){
    drawerScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('ch-drawer-open');
    document.body.classList.add('ch-drawer-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + drawerScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockDrawerScroll(){
    document.documentElement.classList.remove('ch-drawer-open');
    document.body.classList.remove('ch-drawer-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, drawerScrollY || 0);
  }
  function openD(){ mask.classList.add('open'); ham.classList.add('open'); ham.setAttribute('aria-expanded','true'); lockDrawerScroll(); }
  function closeD(){ mask.classList.remove('open'); ham.classList.remove('open'); ham.setAttribute('aria-expanded','false'); unlockDrawerScroll(); }
  ham.addEventListener('click', openD);
  pc.addEventListener('click', closeD);
  mask.addEventListener('click', function(e){ if(e.target===mask) closeD(); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && mask.classList.contains('open')) closeD();
  });
  document.querySelectorAll('.ch-panel-nav .ch-panel-toggle[data-acc-btn]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var controlsId = btn.getAttribute('aria-controls');
      var sub = controlsId ? document.getElementById(controlsId) : null;
      if (!sub) return;

      var li = btn.closest('li');
      if (!li) return;

      var willOpen = !li.classList.contains('open');

      // Cierra hermanos del mismo nivel
      var parentList = li.parentElement;
      if (parentList) {
        parentList.querySelectorAll(':scope > li.open').forEach(function(other){
          if (other === li) return;
          other.classList.remove('open');
          var otherBtn = other.querySelector('.ch-panel-toggle[data-acc-btn]');
          if (otherBtn) {
            var otherId = otherBtn.getAttribute('aria-controls');
            var otherSub = otherId ? document.getElementById(otherId) : null;
            if (otherSub) otherSub.classList.remove('open');
            otherBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      li.classList.toggle('open', willOpen);
      sub.classList.toggle('open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  // ══ CAROUSEL en megamenu ══
  var megaProductsCache = {};
  var megaVariantCache = {};
  var megaProductMetaCache = {};
  function escHtml(s){
    return String(s || '').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function formatMegaMoney(v){
    var n = parseFloat(v);
    if (isNaN(n) || n <= 0) return '';
    if (n > 9999) n = n / 100;
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n);
  }
  function getMegaPriceValue(product){
    if (!product) return '';
    if (product.variants && product.variants.length && product.variants[0] && product.variants[0].price) {
      return product.variants[0].price;
    }
    return product.price_min || product.price || product.price_max || '';
  }
  function getMegaComparePrice(product){
    if (!product) return '';
    if (product.variants && product.variants.length && product.variants[0] && product.variants[0].compare_at_price) {
      return product.variants[0].compare_at_price;
    }
    return product.compare_at_price_min || product.compare_at_price || '';
  }

  function getHandleFromUrl(url){
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m && m[1] ? m[1] : '';
  }
  function getVariantIdFromProduct(p){
    if (!p || !p.variants || !p.variants.length) return '';
    return p.variants[0] && p.variants[0].id ? String(p.variants[0].id) : '';
  }
  var TRACK_CATEGORY_MAP = {
    'kitchen': 'kitchen',
    'storage-organisation': 'storage',
    'bathroom': 'bathroom',
    'home-decor-living': 'living',
    'home-office-desk': 'office',
    'pets': 'pets',
    'kids': 'kids'
  };
  function tagCategory(product){
    return (Array.isArray(product.tags) ? product.tags : (product.tags ? product.tags.split(',') : [])).reduce(function(a,t){return a||(t.trim().indexOf('cat:')===0?t.trim().replace('cat:',''):'')},'');
  }
  function buildWishlistSquare(product, categoryLabel){
    var pid = product && product.id ? String(product.id) : '';
    var title = product && product.title ? product.title : '';
    var url = product && product.url ? product.url : '';
    var rawImage = product && product.image && product.image.src ? product.image.src : (product && product.images && product.images[0] && product.images[0].src ? product.images[0].src : '');
    var priceLabel = formatMegaMoney(getMegaPriceValue(product));
    var category = categoryLabel || tagCategory(product);
    return '<button class="ch-wl-sq"'
      + ' data-wishlist-btn'
      + ' data-product-id="' + escHtml(pid) + '"'
      + ' data-product-title="' + escHtml(title) + '"'
      + ' data-product-url="' + escHtml(url) + '"'
      + ' data-product-image="' + escHtml(rawImage || '') + '"'
      + ' data-product-price="' + escHtml(priceLabel || '') + '"'
      + ' data-variant-id="' + escHtml(product.variants && product.variants[0] ? String(product.variants[0].id) : '') + '"'
      + ' data-category="' + escHtml(category) + '"'
      + ' aria-label="Add ' + escHtml(title) + ' to wishlist"'
      + ' aria-pressed="false"'
      + ' type="button">'
      + '<span class="ch-wl-icon ch-wl-icon--empty" aria-hidden="true">'
      + '<svg width="15" height="15" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50 82 L14 46 L14 28 L28 14 L42 14 L50 22 L58 14 L72 14 L86 28 L86 46 Z" stroke="currentColor" stroke-width="7" stroke-linejoin="round" fill="none"/></svg>'
      + '</span>'
      + '<span class="ch-wl-icon ch-wl-icon--filled" aria-hidden="true" style="display:none">'
      + '<svg width="15" height="15" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M50 82 L14 46 L14 28 L28 14 L42 14 L50 22 L58 14 L72 14 L86 28 L86 46 Z" stroke="currentColor" stroke-width="7" stroke-linejoin="round"/></svg>'
      + '</span>'
      + '</button>';
  }
  function buildCardActions(variantId, handle, product){
    return '<span class="ch-card-actions">'
      + '<button type="button" class="ch-card-atc ch-mega-atc-btn ch-mega-atc" data-variant-id="' + escHtml(variantId || '') + '" data-handle="' + escHtml(handle || '') + '">'
      + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>'
      + '<span class="ch-mega-atc-label">Add to cart</span>'
      + '</button>'
      + '</span>';
  }

  function buildMegaCards(products, categoryLabel){
    var ph = '<div class="ch-card-ph"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C17B5E" stroke-width="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>';
    return (products || []).map(function(p){
      var title = escHtml(p.title);
      var url = p.url || ('/products/' + p.handle);
      var rawImage = p.image && p.image.src ? p.image.src : (p.images && p.images[0] && p.images[0].src ? p.images[0].src : '');
      var priceValue = getMegaPriceValue(p);
     var price = formatMegaMoney(priceValue);
    var compareValue = getMegaComparePrice(p);
    var comparePrice = compareValue && compareValue > priceValue ? formatMegaMoney(compareValue) : '';

      var handle = p.handle || getHandleFromUrl(url);
      var variantId = getVariantIdFromProduct(p);
      if (handle && variantId) megaVariantCache[handle] = variantId;
      var imgTag = rawImage ? '<img class="ch-card-img" src="' + escHtml(rawImage) + '" alt="' + title + '" width="300" height="300" loading="lazy">' : ph;
      var wlOverlay = '<div class="ch-card-wl-overlay">' + buildWishlistSquare(p, categoryLabel) + '</div>';
      var img = '<div class="ch-card-img-wrap" style="position:relative">' + imgTag + wlOverlay + '</div>';
      var eta = buildShippingEtaHtml('mega');
return '<div class="ch-card"><a href="' + escHtml(url) + '" class="ch-card-link">' + img + '<span class="ch-card-name">' + title + '</span><div class="ch-card-prices"><span class="ch-card-price">' + escHtml(price || '—') + '</span>' + (comparePrice ? '<span class="ch-card-compare-price">' + escHtml(comparePrice) + '</span>' : '') + '</div>' + eta + '</a>' + buildCardActions(variantId, handle, p) + '</div>';
    }).join('');
  }

  function ensureMegaCardEta(track){
    if (!track) return;
    track.querySelectorAll('.ch-card').forEach(function(card){
      var link = card.querySelector('.ch-card-link') || card.querySelector('a[href]');
      if (!link || link.querySelector('.ch-card-eta')) return;
      var priceEl = link.querySelector('.ch-card-price');
      if (!priceEl) return;
      priceEl.insertAdjacentHTML('afterend', buildShippingEtaHtml('mega'));
    });
  }
  function normalizeCardNode(card){
    if (!card || card.tagName !== 'A') return card;
    var parent = card.parentNode;
    if (!parent) return card;
    var wrapper = document.createElement('div');
    wrapper.className = 'ch-card';
    card.classList.remove('ch-card');
    card.classList.add('ch-card-link');
    parent.insertBefore(wrapper, card);
    wrapper.appendChild(card);
    return wrapper;
  }
  function ensureCardActions(track){
    if (!track) return;
    track.querySelectorAll('.ch-card, a.ch-card').forEach(function(node){
      var card = normalizeCardNode(node);
      if (card.querySelector('.ch-card-actions')) return;
      var link = card.querySelector('.ch-card-link') || card.querySelector('a[href]');
      var url = link ? (link.getAttribute('href') || '') : '';
      var handle = getHandleFromUrl(url);
      var titleEl = card.querySelector('.ch-card-name');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var imageEl = card.querySelector('.ch-card-img');
      var imageSrc = imageEl ? imageEl.getAttribute('src') : '';
      var priceEl = card.querySelector('.ch-card-price');
      var priceText = priceEl ? priceEl.textContent.trim() : '';
      var variantId = handle && megaVariantCache[handle] ? megaVariantCache[handle] : '';
      card.insertAdjacentHTML('beforeend', buildCardActions(variantId, handle, {
        id: '',
        title: title,
        url: url,
        image: { src: imageSrc },
        price_min: priceText
      }));
    });
  }
  function resolveVariantId(handle){
    if (!handle) return Promise.resolve('');
    if (megaVariantCache[handle]) return Promise.resolve(megaVariantCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('product lookup failed')); })
      .then(function(p){
        var id = getVariantIdFromProduct(p);
        if (id) megaVariantCache[handle] = id;
        return id;
      })
      .catch(function(){ return ''; });
  }
  function getMegaWishlistItems(){
    try { return JSON.parse(localStorage.getItem('ch_wishlist') || '[]'); } catch (e) { return []; }
  }
  function setMegaWishlistItems(items){
    try { localStorage.setItem('ch_wishlist', JSON.stringify(items)); } catch (e) {}
  }
  function setWishlistButtonVisual(btn, active){
    if (!btn) return;
    btn.classList.toggle('ch-wl-active', !!active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var emptyIcon = btn.querySelector('.ch-wl-icon--empty');
    var filledIcon = btn.querySelector('.ch-wl-icon--filled');
    if (emptyIcon) emptyIcon.style.display = active ? 'none' : 'inline-flex';
    if (filledIcon) filledIcon.style.display = active ? 'inline-flex' : 'none';
  }
  function syncMegaWishlistButtonsState(){
    var list = getMegaWishlistItems();
    document.querySelectorAll('.ch-card .ch-wl-sq[data-wishlist-btn]').forEach(function(btn){
      var pid = String(btn.getAttribute('data-product-id') || '');
      var url = String(btn.getAttribute('data-product-url') || '');
      var isOn = list.some(function(item){
        return (pid && String(item && item.id) === pid) || (url && String(item && item.url) === url);
      });
      setWishlistButtonVisual(btn, isOn);
    });
  }
  function resolveProductMetaFromHandle(handle){
    if (!handle) return Promise.resolve(null);
    if (megaProductMetaCache[handle]) return Promise.resolve(megaProductMetaCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('product meta failed')); })
      .then(function(p){
        var meta = {
          id: p && p.id ? String(p.id) : '',
          title: p && p.title ? p.title : '',
          url: p && p.url ? p.url : ('/products/' + handle),
          image: p && p.featured_image ? p.featured_image : '',
          price: formatMegaMoney(getMegaPriceValue(p))
        };
        megaProductMetaCache[handle] = meta;
        return meta;
      })
      .catch(function(){ return null; });
  }
  function bindMegaWishlistButtons(scope){
    var root = scope || document;
    root.querySelectorAll('.ch-card .ch-wl-sq[data-wishlist-btn]').forEach(function(btn){
      if (btn.dataset.megaWlBound === '1') return;
      btn.dataset.megaWlBound = '1';
    });
    document.dispatchEvent(new Event('shopify:section:load'));
    syncMegaWishlistButtonsState();
    if (window.CHWishlist && typeof window.CHWishlist.initBtns === 'function') {
      window.CHWishlist.initBtns();
    }
  }
  function updateCartBadge(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function refreshCartCount(){
    return fetch('/cart.js')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('cart fetch failed')); })
      .then(function(cart){
        updateCartBadge(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
      })
      .catch(function(){});
  }
  function refreshWishlistCountFromStorage(){
    try {
      var count = 0;
      var v2raw = localStorage.getItem('ch_wishlist_v2');
      if (v2raw) {
        var v2 = JSON.parse(v2raw);
        count = (v2 && v2.folders && v2.folders['all-my-wishlist'] && Array.isArray(v2.folders['all-my-wishlist'].items))
          ? v2.folders['all-my-wishlist'].items.length : 0;
      } else {
        /* fallback v1 para usuarios sin migración todavía */
        count = JSON.parse(localStorage.getItem('ch_wishlist') || '[]').length;
      }
      document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }
  function fetchMegaBestSelling(handle){
    if (!handle) return Promise.resolve([]);
    if (megaProductsCache[handle]) return Promise.resolve(megaProductsCache[handle]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=8&sort_by=best-selling')
      .then(function(r){ return r.ok ? r.json() : Promise.reject(new Error('best-selling failed')); })
      .then(function(d){
        var products = (d && d.products) ? d.products.filter(function(p){ return p && p.available !== false; }) : [];
        megaProductsCache[handle] = products;
        return products;
      })
      .catch(function(){
        megaProductsCache[handle] = [];
        return [];
      });
  }
  /* Las tarjetas del mega menu llegan dentro de <template data-mega-cards>
     (inertes: el navegador no las construye ni las pinta). Se montan cuando
     el navegador queda libre tras la carga, una categoria por hueco libre,
     o de forma sincrona al primer hover de su categoria si llega antes, asi
     que al abrir el menu ya estan puestas y no hay salto. En tactil el nav
     de escritorio no se muestra (pointer: coarse) y no se montan nunca. */
  var megaMountQueue = [];
  var megaMountScheduled = false;
  function scheduleMegaMount(fn){
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    megaMountQueue.push(fn);
    if (megaMountScheduled) return;
    megaMountScheduled = true;
    var idle = window.requestIdleCallback || function(cb){ return setTimeout(cb, 50); };
    function step(){
      var f = megaMountQueue.shift();
      if (!f) return;
      f();
      idle(step);
    }
    function run(){ idle(step); }
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }
  document.querySelectorAll('.ch-mega').forEach(function(mega){
    var track = mega.querySelector('[data-track]');
    var trackWrap = track ? track.parentElement : null;
    var dotsEl= mega.querySelector('[data-dots]');
    var prev  = mega.querySelector('[data-prev]');
    var next  = mega.querySelector('[data-next]');
    if(!track) return;
    var navItem = mega.closest('.ch-nav-item');
    var cur = 0;
    var maxS = 0;
    var dotCount = 0;
    var cW = 172;
    var cTimer = null;
    function stopAuto(){
      if (cTimer) {
        clearInterval(cTimer);
        cTimer = null;
      }
    }
    function startAuto(){
      stopAuto();
      if (maxS <= 0) return;
      cTimer = setInterval(function(){ goTo(cur>=maxS ? 0 : cur+1); }, 2800);
    }
    function getVisibleCards(){
      var wrapWidth = trackWrap ? trackWrap.clientWidth : track.clientWidth;
      if (!wrapWidth || !cW) return window.innerWidth >= 1360 ? 3 : 2;
      return Math.max(1, Math.floor((wrapWidth + 12) / cW));
    }
    function syncDots(){
      if(!dotsEl || maxS <= 0) return;
      var dots = dotsEl.querySelectorAll('.ch-car-dot');
      if (!dots.length) return;
      var activeDot = dotCount === 1 ? 0 : Math.round((cur / maxS) * (dotCount - 1));
      dots.forEach(function(d,i){ d.classList.toggle('on', i === activeDot); });
    }
    function goTo(n){
      cur = Math.max(0, Math.min(n, maxS));
      track.style.transform = 'translateX(-' + (cur * cW) + 'px)';
      syncDots();
    }
    function setupCarousel(){
      var cards = track.querySelectorAll('.ch-card');
      var total = cards.length;
      var firstCard = cards[0];
      cW = firstCard ? firstCard.offsetWidth + 12 : 172;
      var vis = getVisibleCards();
      maxS = Math.max(0, total - vis);
      if (trackWrap) trackWrap.classList.toggle('ch-track-wrap--peek', maxS > 0);
      cur = 0;
      track.style.transform = 'translateX(0)';
      if (dotsEl) dotsEl.innerHTML = '';
      dotCount = Math.min(maxS + 1, 5);
      if (maxS <= 0) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (dotsEl) dotsEl.style.display = 'none';
      } else {
        if (prev) prev.style.display = '';
        if (next) next.style.display = '';
        if (dotsEl) dotsEl.style.display = '';
        if (dotsEl){
          for(var i=0;i<dotCount;i++){
            var target = dotCount === 1 ? 0 : Math.round((i * maxS) / (dotCount - 1));
            var d=document.createElement('button');
            d.className='ch-car-dot'+(i===0?' on':'');
            d.setAttribute('aria-label','Slide '+(i+1));
            (function(idx){ d.addEventListener('click', function(){ goTo(idx); }); })(target);
            dotsEl.appendChild(d);
          }
        }
      }
      syncDots();
      /* El autoplay solo corre con el menu abierto, no en segundo plano */
      if (!navItem || navItem.matches(':hover')) startAuto();
      bindMegaWishlistButtons(track);
      ensureMegaCardEta(track);
    }
    mega.addEventListener('mouseenter',function(){ stopAuto(); });
    mega.addEventListener('mouseleave',function(){ startAuto(); });
    if(prev) prev.addEventListener('click',function(){ if (maxS > 0) goTo(cur>0?cur-1:maxS); });
    if(next) next.addEventListener('click',function(){ if (maxS > 0) goTo(cur<maxS?cur+1:0); });
    var mounted = false;
    function mountCards(){
      if (mounted) return;
      mounted = true;
      var tpl = track.querySelector('template[data-mega-cards]');
      if (tpl) track.replaceChildren(tpl.content.cloneNode(true));
      setupCarousel();
      ensureCardActions(track);
      ensureMegaCardEta(track);
      bindMegaWishlistButtons(track);
    }
    var handle = track.getAttribute('data-collection-handle');
    var categoryLabel = TRACK_CATEGORY_MAP[handle] || '';
    var megaFetched = false;
    function fetchMegaOnce(){
      if (megaFetched) return;
      megaFetched = true;
      fetchMegaBestSelling(handle).then(function(products){
        if (!products || !products.length) return;
        mounted = true;
        track.innerHTML = buildMegaCards(products, categoryLabel);
        setupCarousel();
        ensureCardActions(track);
        ensureMegaCardEta(track);
        bindMegaWishlistButtons(track);
      });
    }
    /* Solo se precarga cuando el usuario pasa el raton por ESE item de
       nav — antes se precargaban las 9 categorias del mega menu en
       cada carga de pagina via requestIdleCallback, aunque casi nadie
       abre todas. */
    if (navItem) {
      /* mountCards va antes que fetchMegaOnce: las tarjetas quedan puestas
         en el mismo evento, antes de que el panel se pinte abierto */
      navItem.addEventListener('mouseenter', mountCards);
      navItem.addEventListener('mouseenter', fetchMegaOnce, { once: true });
      navItem.addEventListener('mouseenter', startAuto);
      navItem.addEventListener('mouseleave', stopAuto);
    } else {
      mountCards();
      fetchMegaOnce();
    }
    scheduleMegaMount(mountCards);
  });
  document.addEventListener('click', function(e){
    if (!e.target || typeof e.target.closest !== 'function') return;
    var atc = e.target.closest('.ch-mega-atc');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = atc.getAttribute('data-variant-id');
      var handle = atc.getAttribute('data-handle');
      var labelEl = atc.querySelector('.ch-mega-atc-label');
      var baseLabel = labelEl ? labelEl.textContent : 'Add to cart';
      resolveVariantId(handle).then(function(id){
        var useId = variantId || id;
        if (!useId) return;
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (labelEl) labelEl.textContent = 'Adding...';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(useId), quantity: 1 })
        }).then(function(){
          atc.classList.remove('is-loading');
          atc.classList.add('is-added');
          if (labelEl) labelEl.textContent = 'Added';
          refreshCartCount();
          var chDrawer = document.querySelector('carlahome-cart-drawer');
          if (chDrawer) { chDrawer.refreshDrawer().then(function(){ chDrawer.open(null); }); }
          setTimeout(function(){
            atc.classList.remove('is-added');
            if (labelEl) labelEl.textContent = baseLabel;
            atc.disabled = false;
          }, 1100);
        }).catch(function(){
          atc.classList.remove('is-loading');
          atc.classList.add('is-error');
          if (labelEl) labelEl.textContent = 'Try again';
          setTimeout(function(){
            atc.classList.remove('is-error');
            if (labelEl) labelEl.textContent = baseLabel;
            atc.disabled = false;
          }, 1200);
        });
      });
      return;
    }
  });
  document.addEventListener('ch:wishlist:change', function(){ refreshWishlistCountFromStorage(); });
  window.addEventListener('storage', function(e){
    if (e.key === 'ch_wishlist_v2' || e.key === 'ch_wishlist') refreshWishlistCountFromStorage();
  });
  refreshCartCount();
  refreshWishlistCountFromStorage();
  bindMegaWishlistButtons(document);

  /* ══ SEARCH PAGE — poblar inputs con el query actual ══ */
  (function(){
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q) return;

    /* Poblar input desktop */
    var desktopInput = document.getElementById('ch-sf');
    if (desktopInput) {
      desktopInput.value = q;
      desktopInput.dispatchEvent(new Event('ch:sync-ph'));
    }

    /* Poblar input mobile */
    var mobileInput = document.getElementById('ch-mob-sf');
    if (mobileInput) {
      mobileInput.value = q;
      mobileInput.dispatchEvent(new Event('ch:sync-ph'));
    }

    /* En mobile (<1024px): asegurarse de que ch-mob-search sea visible */
    if (window.innerWidth <= 1024) {
      var mobSearch = document.getElementById('ch-mob-search');
      if (mobSearch) {
        mobSearch.style.display = 'block';
      }
    }
  })();

})();

(function() {
  function getSearchNavH() {
    var searchEl = document.querySelector('.ch-header-search-band');
    var navEl = document.querySelector('.ch-nav-band');
    var mobSearchEl = document.querySelector('.ch-mob-search');
    var searchH = searchEl ? searchEl.offsetHeight : 52;
    var navH = (navEl && navEl.offsetParent !== null) ? navEl.offsetHeight : 0;
    var mobSearchH = (mobSearchEl && mobSearchEl.offsetParent !== null) ? mobSearchEl.offsetHeight : 0;
    return searchH + navH + mobSearchH;
  }
  /* Cache: solo cambia con resize, nunca durante scroll — evita forzar
     reflow (lectura de offsetHeight) en cada evento de scroll. */
  var searchNavH = getSearchNavH();
  /* --ch-fixed-h = solo la parte con position:fixed del header (search +
     nav + mob-search). No suma --ch-ann-h porque la ann bar es sticky y
     ya empuja el contenido por flujo normal del documento -- sumarla de
     nuevo en el padding-top de MainContent duplicaba ese espacio. */
  document.documentElement.style.setProperty('--ch-fixed-h', searchNavH + 'px');
  function refreshSearchNavH() {
    searchNavH = getSearchNavH();
    document.documentElement.style.setProperty('--ch-fixed-h', searchNavH + 'px');
  }
  function updateAnnHeight() {
    var bar = document.getElementById('ch-ann-bar');
    var h = bar && bar.offsetParent !== null ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--ch-ann-h', h + 'px');
    document.documentElement.style.setProperty('--ch-header-h', (h + searchNavH) + 'px');
  }

  function initAnnSlider() {
    var slides = document.querySelectorAll('.ch-ann-slide');
    if (slides.length <= 1) return;
    var current = 0;
    var interval = (window.chHeaderConfig && window.chHeaderConfig.annSpeedMs) || 5000;
    function showSlide(idx) {
      slides.forEach(function(s, i) {
        s.classList.toggle('ch-ann-slide--active', i === idx);
        s.style.opacity = i === idx ? '1' : '0';
        s.style.position = i === idx ? 'relative' : 'absolute';
      });
    }
    setInterval(function() {
      current = (current + 1) % slides.length;
      showSlide(current);
    }, interval);
  }

  document.addEventListener('click', function(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var slide = e.target.closest('.ch-ann-slide[data-url]');
    if (slide) window.location.href = slide.dataset.url;
  });

  document.addEventListener('DOMContentLoaded', function() {
    updateAnnHeight();
    initAnnSlider();
  });
  window.addEventListener('resize', function() {
    refreshSearchNavH();
    updateAnnHeight();
  });

  var annBarEl = document.getElementById('ch-ann-bar');
  if (annBarEl) {
    var annBarElH = annBarEl.offsetHeight;
    document.documentElement.style.setProperty('--ch-ann-h', annBarElH + 'px');
    document.documentElement.style.setProperty('--ch-header-h', (annBarElH + searchNavH) + 'px');
  }

  var outer = document.getElementById('ch-outer');
  var annH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ch-ann-h')) || 29;
  window.addEventListener('scroll', function() {
    var t = Math.max(0, annH - window.scrollY);
    outer.style.top = t + 'px';
    document.documentElement.style.setProperty('--ch-ann-h', t + 'px');
    document.documentElement.style.setProperty('--ch-header-h', (t + searchNavH) + 'px');
  }, { passive: true });

})();
